import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdmin } from "./AdminContext";
import { LogOut, LayoutDashboard, Settings, KeyRound, BookMarked, MessageSquareQuote, Mail, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Genel", icon: LayoutDashboard, end: true },
  { to: "/admin/yorumlar", label: "Yorumlar", icon: MessageSquareQuote },
  { to: "/admin/referanslar", label: "Referanslar", icon: BookMarked },
  { to: "/admin/mesajlar", label: "Mesajlar", icon: Mail },
  { to: "/admin/site-ayarlari", label: "Site Ayarları", icon: Settings },
  { to: "/admin/hesap", label: "Hesap Ayarları", icon: KeyRound },
];

export default function AdminLayout() {
  const { token, user, loading, logout } = useAdmin();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen bg-[#0A0A0A] text-white/60 flex items-center justify-center">Yükleniyor...</div>;
  }
  if (!token || !user) return <Navigate to="/admin/login" replace />;

  const handleLogout = () => { logout(); navigate("/admin/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex" data-testid="admin-shell">
      {/* Sidebar */}
      <aside className="hidden lg:flex w-72 flex-col border-r border-white/10 bg-[#0A0A0A]">
        <div className="px-6 py-7 border-b border-white/10 flex items-center gap-3">
          <img src="/logos/pt-plus-mark.png" alt="Pratik Teknoloji" className="h-10 w-10 flex-none" />
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#FF3B30]">Pratik Teknoloji</div>
            <div className="mt-0.5 font-display text-base font-bold leading-tight">Yönetim Paneli</div>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}
              data-testid={`admin-nav-${to.split("/").pop() || "index"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? "bg-[#FF3B30]/15 text-[#FF3B30] border border-[#FF3B30]/30" : "text-white/70 hover:bg-white/5 hover:text-white border border-transparent"
                }`
              }
            >
              <Icon size={17} strokeWidth={1.8} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <a href="/" className="flex items-center justify-between text-xs text-white/50 hover:text-white px-4 py-2 rounded-xl hover:bg-white/5">
            Siteyi Görüntüle <ArrowUpRight size={14} />
          </a>
          <div className="flex items-center justify-between px-4 py-2 rounded-xl bg-white/[0.03] border border-white/10">
            <div>
              <div className="text-xs text-white/40">Giriş yapan</div>
              <div className="text-sm font-semibold">{user.username}</div>
            </div>
            <button onClick={handleLogout} data-testid="admin-logout" title="Çıkış" className="text-white/60 hover:text-[#FF3B30]">
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile header */}
        <header className="lg:hidden sticky top-0 z-20 bg-[#0A0A0A]/95 backdrop-blur border-b border-white/10 px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img src="/logos/pt-plus-mark.png" alt="" className="h-7 w-7" />
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#FF3B30]">Pratik</div>
              <div className="text-sm font-semibold leading-tight">Yönetim Paneli</div>
            </div>
          </div>
          <button onClick={handleLogout} className="text-white/70 hover:text-[#FF3B30]" data-testid="admin-logout-mobile"><LogOut size={18} /></button>
        </header>

        {/* Mobile nav */}
        <nav className="lg:hidden border-b border-white/10 overflow-x-auto bg-[#0A0A0A]">
          <div className="flex gap-1 px-3 py-2 min-w-max">
            {NAV.map(({ to, label, end }) => (
              <NavLink key={to} to={to} end={end}
                className={({ isActive }) => `whitespace-nowrap px-3 py-2 rounded-lg text-xs font-semibold ${
                  isActive ? "bg-[#FF3B30]/15 text-[#FF3B30]" : "text-white/60"
                }`}
              >{label}</NavLink>
            ))}
          </div>
        </nav>

        <main className="flex-1 p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
